import React from 'react';
import dayjs from 'dayjs';
import { PermissionName } from '../../valueobject/permissionName';
import { useSessionStore } from '../../context/session';
import { LoginPage } from '../pages/login';
import { Messages } from '../../constant/messages';
import { BusinessTypeKeys } from '../../constant';

type Props = {
  permission: PermissionName;
  businessTypes?: BusinessTypeKeys[];
  readwrite?: boolean;
  element: React.ReactNode;
};

export const Restricted: React.FC<Props> = ({ permission, businessTypes, readwrite, element }) => {
  const { hasSession, hasPermission, logoutTime, selectedDivisionId, selectedFloorGroupId } = useSessionStore((state) => state);

  if (selectedDivisionId === 0 || selectedFloorGroupId === 0) {
    console.log('no selected division id or floor group id');
    return <LoginPage key={'has-no-session'} error={Messages.ERR_401} />;
  }

  if (!hasSession) {
    console.log('no session');
    if (logoutTime && logoutTime.isBefore(dayjs().add(5, 'second'))) {
      return <LoginPage key={'has-no-session'}/>;
    }

    return <LoginPage key={'has-no-session'} error={Messages.ERR_401} />;
  }

  if (!hasPermission(permission, readwrite, businessTypes)) {
    console.log('no permission');
    return (
        <div style={{ margin: '40px', textAlign: 'center' }}>
          権限がありません。
        </div>
    );
  }

  return element;
};
